<h5
  class="h5"
  mat-dialog-title>
  Copy user settings
</h5>

<mat-dialog-content class="dialog-content">
  <mat-form-field class="full-width">
    <mat-label>Donor</mat-label>
    <input
      matInput
      [formControl]="donorControl"
      [matAutocomplete]="donorAuto"
      placeholder="Search by name or email" />
    @if (donor()) {
      <mat-icon
        matSuffix
        (click)="clearDonor($event)">
        close
      </mat-icon>
    }
    <mat-autocomplete
      #donorAuto
      [displayWith]="displayUser"
      (optionSelected)="onDonorSelected($event)">
      @for (user of filteredDonors(); track user.id) {
        <mat-option [value]="user">
          {{ user | fullName }}
          <span class="option-email">{{ user.email }}</span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <div class="recipients-section">
    <mat-form-field class="full-width">
      <mat-label>Search recipients</mat-label>
      <input
        matInput
        [value]="recipientSearch()"
        [disabled]="!donor()"
        (input)="recipientSearch.set($any($event.target).value)" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div
      class="recipients-list"
      [class.list-disabled]="!donor()">
      @if (loading()) {
        <div class="loading-state">
          <mat-spinner diameter="28" />
        </div>
      } @else {
        <div class="select-all-row">
          <mat-checkbox
            color="primary"
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            [disabled]="!donor() || !filteredRecipients().length"
            (change)="toggleAll()">
            <span class="select-all-label">Select all</span>
          </mat-checkbox>
          @if (selectedCount()) {
            <span class="selected-badge">{{ selectedCount() }} selected</span>
          }
        </div>

        <div class="list-items">
          @for (user of filteredRecipients(); track user.id) {
            <div
              class="user-row"
              (click)="toggleRecipient(user.id)">
              <mat-checkbox
                color="primary"
                [checked]="selectedIds().has(user.id)"
                [disabled]="!donor()"
                (click)="$event.stopPropagation()"
                (change)="toggleRecipient(user.id)">
              </mat-checkbox>
              <div class="user-info">
                <span class="user-name">{{ user | fullName }}</span>
                <span class="user-email">{{ user.email }}</span>
              </div>
            </div>
          } @empty {
            <p class="empty-message">No users found</p>
          }
        </div>
      }
    </div>
  </div>

  <p class="warning-text">The current user settings of the selected members will be replaced.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button
    variant="stroked"
    color="neutral"
    mat-dialog-close>
    Cancel
  </app-button>
  <app-button
    [disabled]="!canCopy()"
    (click)="copy()">
    Copy
  </app-button>
</mat-dialog-actions>
